const STORAGE_KEY = 'studio_recent_elements';

const safeParse = (value) => {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

export const getRecentIds = () => {
  if (typeof window === 'undefined') return [];
  return safeParse(window.localStorage.getItem(STORAGE_KEY));
};

export const setRecentIds = (ids = []) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
};

export const addRecentId = (id, max = 60) => {
  if (!id || typeof window === 'undefined') return [];
  const current = getRecentIds();
  const next = [id, ...current.filter((item) => item !== id)].slice(0, max);
  setRecentIds(next);
  return next;
};

export const clearRecent = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(STORAGE_KEY);
};
